import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../../login/login.service';
import { CtbCcService } from '../../../catalogo/ctb-cc/ctb-cc.service';
import { PolService } from '../../../catalogo/ctb-pol/ctb-pol.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

@Component({
  selector: 'app-gastos-sucursal',
  templateUrl: './gastos-sucursal.component.html',
  styleUrls: ['./gastos-sucursal.component.css'],
  providers: [PolService]
})
export class GastosSucursalComponent implements OnInit {
  public mes_inicial: number;
  public mes_final: number;
  public ano: number;
  public gral_suc_id: number;
  public sucursales: any[] = [];
  public anos: any[] = [];
  public reporte: any = {};

  constructor(private polService: PolService,private ctbCcService: CtbCcService, private loginService: LoginService) { }

  ngOnInit(): void {
    this.mes_inicial = 1;
    this.mes_final = new Date().getMonth()+1;
    this.gral_suc_id = 0;
    this.cargarAnos();
    this.cargarSucursales();
    this.cargarReporte(false);
  }
  cargarSucursales(){
    this.polService.getSucursalByIdEmp(this.loginService.usuario.empresa_seleccionada.id).subscribe(
      response =>{
        this.sucursales = response.contenido;
      }
    );
  }
  cargarAnos() {
    const ejercicios = JSON.parse(String(localStorage.getItem('ejercicios')));
    for (let x = 0; x < ejercicios.length; x++) {
      this.anos.push(ejercicios[x].anio);
    }
    this.ano = this.loginService.ejercicio;
    // this.cargarReporte();
  }  
  cargarReporte(actualizar_select: boolean) {
    console.log(this.gral_suc_id);
    this.ctbCcService.getReporteGastosSucursal(this.mes_inicial, this.mes_final, this.ano, this.gral_suc_id, this.loginService.empresa).subscribe(
      response => {
        this.reporte = response.contenido;
        console.log(this.reporte);
        if (actualizar_select) {

        }
      }
    );
  }
  exportAsXLSX() {
    this.ctbCcService.getRepGasSucXlsx(this.mes_inicial, this.mes_final, this.ano, this.gral_suc_id, this.loginService.empresa).subscribe(
      response => {
        console.log(response);
        const a = document.createElement('a');
        const titulo_pdf = 'GS-' + this.mes_inicial + '-' + this.mes_final + '-' + this.ano;
        a.href = URL.createObjectURL(response);
        a.download = titulo_pdf + '.xls';
        document.body.appendChild(a);
        a.click();
      }
    );
  } 
  exportAsPdf() {
    this.ctbCcService.getRepGasSucPdf(this.mes_inicial, this.mes_final, this.ano, this.gral_suc_id, this.loginService.empresa).subscribe(
      response => {
        console.log(response);
        const a = document.createElement('a');
        const titulo_pdf = 'GS-' + this.mes_inicial + '-' + this.mes_final + '-' + this.ano;
        a.href = URL.createObjectURL(response);
        a.download = titulo_pdf + '.pdf';
        document.body.appendChild(a);
        a.click();
      }
    );
  }
}
